import React from "react";

import talentlenzAccessModelsChannelMap from "../../images/talentlenz-access-models-channel-map.svg";
import talentlenzAccessModelsLinkOnlyIcon from "../../images/talentlenz-access-models-link-only-icon.svg";
import talentlenzAccessModelsPrivateIcon from "../../images/talentlenz-access-models-private-icon.svg";
import talentlenzAccessModelsPublicIcon from "../../images/talentlenz-access-models-public-icon.svg";
import talentlenzAccessModelsQrOpportunityPoster from "../../images/talentlenz-access-models-qr-opportunity-poster.svg";

import "./TalentLenzAccessModels.css";

const TALENTLENZ_ACCESS_MODEL_OPTIONS = [
  {
    id: "public",
    title: "Public",
    description: "Visible to everyone",
    icon: talentlenzAccessModelsPublicIcon,
  },
  {
    id: "link-only",
    title: "Link-only",
    description: "Unique link or QR",
    icon: talentlenzAccessModelsLinkOnlyIcon,
  },
  {
    id: "private",
    title: "Private",
    description: "Invitation only",
    icon: talentlenzAccessModelsPrivateIcon,
  },
];

function TalentLenzAccessModels() {
  return (
    <section
      id="talentlenz-access-models"
      className="talentlenz-access-models-section"
      aria-labelledby="talentlenz-access-models-title"
    >
      <div className="talentlenz-access-models-section__inner">
        <header className="talentlenz-access-models-section__heading">
          <p className="talentlenz-access-models-section__eyebrow">
            Control access
          </p>

          <h2
            id="talentlenz-access-models-title"
            className="talentlenz-access-models-section__title"
          >
            <span className="talentlenz-access-models-section__title-lines talentlenz-access-models-section__title-lines--wide">
              Publish every opportunity
              <br />
              the right way.
            </span>

            <span className="talentlenz-access-models-section__title-lines talentlenz-access-models-section__title-lines--landscape">
              Publish every
              <br />
              opportunity
              <br />
              the right way.
            </span>

            <span className="talentlenz-access-models-section__title-lines talentlenz-access-models-section__title-lines--mobile">
              Publish every
              <br />
              opportunity the
              <br />
              right way.
            </span>
          </h2>
        </header>

        <p className="talentlenz-access-models-section__description">
          <span className="talentlenz-access-models-section__description-lines talentlenz-access-models-section__description-lines--desktop">
            Open it to everyone, share a unique link or QR code,
            <br />
            or invite selected applicants privately. You control
            <br />
            who can apply and what each person must submit.
          </span>

          <span className="talentlenz-access-models-section__description-lines talentlenz-access-models-section__description-lines--landscape">
            Open it to everyone, share a unique link
            <br />
            or QR code, or invite selected applicants
            <br />
            privately. You control who can apply and
            <br />
            what each person must submit.
          </span>

          <span className="talentlenz-access-models-section__description-lines talentlenz-access-models-section__description-lines--portrait">
            Open it to everyone, share a unique link or QR code, or invite
            <br />
            selected applicants privately. You control who can apply and
            <br />
            what each person must submit.
          </span>

          <span className="talentlenz-access-models-section__description-lines talentlenz-access-models-section__description-lines--mobile">
            Open it to everyone, share a unique link
            <br />
            or QR code, or invite selected applicants
            <br />
            privately. You control who can apply and
            <br />
            what each person must submit.
          </span>
        </p>

        <aside className="talentlenz-access-models-section__configuration-note">
          <span
            className="talentlenz-access-models-section__configuration-dot"
            aria-hidden="true"
          />

          <span className="talentlenz-access-models-section__configuration-text">
            Public. Link-only. Private. Fully configurable.
          </span>
        </aside>

        <figure className="talentlenz-access-models-section__channel-map-panel">
          <img
            className="talentlenz-access-models-section__channel-map-image"
            src={talentlenzAccessModelsChannelMap}
            alt="A Senior Mine Planner opportunity connected to public, link-only and private TalentLenz application routes."
            loading="lazy"
            decoding="async"
          />
        </figure>

        <div className="talentlenz-access-models-section__compact-layout">
          <ul
            className="talentlenz-access-models-section__access-option-list"
            aria-label="TalentLenz opportunity access routes"
          >
            {TALENTLENZ_ACCESS_MODEL_OPTIONS.map((option) => (
              <li
                key={option.id}
                className={[
                  "talentlenz-access-models-section__access-option",
                  `talentlenz-access-models-section__access-option--${option.id}`,
                ].join(" ")}
              >
                <img
                  className="talentlenz-access-models-section__access-option-icon"
                  src={option.icon}
                  alt=""
                  aria-hidden="true"
                  loading="lazy"
                  decoding="async"
                />

                <span className="talentlenz-access-models-section__access-option-copy">
                  <strong className="talentlenz-access-models-section__access-option-title">
                    {option.title}
                  </strong>

                  <small className="talentlenz-access-models-section__access-option-description">
                    {option.description}
                  </small>
                </span>
              </li>
            ))}
          </ul>

          <img
            className="talentlenz-access-models-section__opportunity-poster"
            src={talentlenzAccessModelsQrOpportunityPoster}
            alt="TalentLenz QR opportunity poster for a Senior Mine Planner position."
            loading="lazy"
            decoding="async"
          />

          <aside className="talentlenz-access-models-section__route-message">
            <p className="talentlenz-access-models-section__route-message-eyebrow">
              One opportunity
            </p>

            <h3 className="talentlenz-access-models-section__route-message-title">
              Choose the
              <br />
              right route
              <br />
              for every
              <br />
              audience.
            </h3>

            <div className="talentlenz-access-models-section__route-control-note">
              <span
                className="talentlenz-access-models-section__route-control-dot"
                aria-hidden="true"
              />

              <span className="talentlenz-access-models-section__route-control-text">
                HR controls access
              </span>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}

export default TalentLenzAccessModels;